/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';

class Redirect extends React.Component {
  componentWillMount() {
    window.location = `/public?=${this.props.intl.locale}`;
  }

  render() {
    return <div />;
  }
}

export default injectIntl(Redirect);




// WEBPACK FOOTER //
// ./src/containers/Redirect/index.jsx